import Tip from '../../Atoms/tip';
import Star from '../../Atoms/Star';
import bem from '../../../utils/bem';

const StarRating = ({ votes, rating, tipText, className, srId }) => {
  const componentClassName = 'm-star-rating';
  const starsStack = [1, 2, 3, 4, 5];
  const lastStar = Math.floor(rating) + 1;
  const lastStarOffset = rating % 1;
  const setFillOffset = (item) => {
    if (item === lastStar) {
      return lastStarOffset;
    }
    if (item > lastStar) {
      return 0;
    }
    return 1;
  };
  const stars = starsStack.map((el) => (
    <Star
      key={srId + el}
      strokeColor="#FF8300"
      accentFillColor="#FF8300"
      baseFillColor="#fff"
      fillOffset={setFillOffset(el)}
      index={el}
      className={bem('star', [], componentClassName)}
      srId={srId + el}
    />
  ));
  return (
    <div className={bem(componentClassName, [], '', [className])}>
      <div className={bem('stars', [], componentClassName)}>{stars}</div>
      <div className={bem('data', [], componentClassName)}>
        <span className={bem('rating', [], componentClassName)}>{rating}</span>{' '}
        {votes && (
          <span className={bem('votes', [], componentClassName)}>
            ({votes})
          </span>
        )}
      </div>
      {tipText && (
        <div className={bem('tip', [], componentClassName)}>
          <Tip content={tipText} />
        </div>
      )}
    </div>
  );
};

export default StarRating;
